
import AppToolbar from '@/_components/bar/appToolbar/appToolbar.vue'
import ProjectMixin from '@/_mixins/project'
import { getRequest, patchRequest } from '@/plugins/api-axios'
import { getURL } from '@/utils/axios'
import { deserialise, serialise } from 'kitsu-core'
import WorkAlertSettings from '@/views/Project/ch/components/workAlert/index.vue'
import TimeDuration from '@/views/Project/ch/components/workAlert/timeDuration.vue'
import JsonApiObject from '@/_models/JsonApi'
import LogActivityDialog from './components/logActivityDialog.vue'

type ProjectSettings = {
    alertOnInvalidCard: boolean
    alertOnCardExpiringWithinDays: Maybe<number>
    assumeCheckOutAfterSeconds: number
    maxRestToIgnoreSeconds: Maybe<number>
    helpText: Maybe<Record<string, string>>
    type: string
    id: string
    updatedAt: string
}

class ProjectSettingsViewModel {
    projectSettings: ProjectSettings

    isSaving = false
    hasChanged = false
    isAlertOnCardExpiringWithinDays = false

    get patchData() {
        return serialise(this.projectSettings.type, {
            id: this.projectSettings.id,
            assumeCheckOutAfterSeconds: this.projectSettings.assumeCheckOutAfterSeconds,
            maxRestToIgnoreSeconds: this.projectSettings.maxRestToIgnoreSeconds,
            alertOnInvalidCard: this.projectSettings.alertOnInvalidCard,
            alertOnCardExpiringWithinDays: this.isAlertOnCardExpiringWithinDays
                ? this.projectSettings.alertOnCardExpiringWithinDays
                : null,
        }).data
    }

    constructor(settings: ProjectSettings) {
        this.projectSettings = settings
        if (this.projectSettings.alertOnCardExpiringWithinDays) {
            this.isAlertOnCardExpiringWithinDays =
                this.projectSettings.alertOnCardExpiringWithinDays > 0
        }
    }
}

export default {
    name: 'ContractorGeneralSetting',
    mixins: [ProjectMixin],
    components: {
        AppToolbar,
        WorkAlertSettings,
        TimeDuration,
    },
    data() {
        return {
            projectSettingsViewModel: null as Maybe<ProjectSettingsViewModel>,
            hierarchy: null as any,
            workAlerts: [] as any[],
        }
    },
    methods: {
        async getWorkAlerts() {
            const { data } = await getRequest(
                getURL({
                    path: `/contractorHierarchies/${this.currentProjectId}`,
                    base: this.contractorBaseUrl,
                    params: {
                        include: 'workAlertDefinitions',
                    },
                })
            )
            this.hierarchy = deserialise(data).data
            if (this.hierarchy) {
                this.workAlerts = this.hierarchy.workAlertDefinitions.data
            }
        },

        async getSettings() {
            const { data } = await getRequest(
                getURL({
                    path: `/projectSettings/${this.currentProjectId}`,
                    base: this.contractorBaseUrl,
                })
            )
            this.projectSettingsViewModel = new ProjectSettingsViewModel(deserialise(data).data)
        },

        async saveGeneralSettings() {
            if (!this.projectSettingsViewModel) return
            try {
                this.projectSettingsViewModel.isSaving = true
                const { data } = await patchRequest(
                    getURL({
                        path: `/projectSettings/${this.currentProjectId}`,
                        base: this.contractorBaseUrl,
                    }),
                    {},
                    this.projectSettingsViewModel.patchData
                )
                this.projectSettingsViewModel = new ProjectSettingsViewModel(deserialise(data).data)
            } finally {
                this.projectSettingsViewModel.isSaving = false
            }
        },
        handleAlertOnCardExpiringWithinDaysChanged() {
            if (!this.projectSettingsViewModel) return

            if (this.projectSettingsViewModel.isAlertOnCardExpiringWithinDays) {
                this.projectSettingsViewModel.projectSettings.alertOnCardExpiringWithinDays =
                    this.projectSettingsViewModel.projectSettings.alertOnCardExpiringWithinDays || 1
            }
            this.projectSettingsViewModel.hasChanged = true
        },
        handleAlertDaysChanged() {
            if (!this.projectSettingsViewModel) return

            if (
                !this.projectSettingsViewModel.projectSettings.alertOnCardExpiringWithinDays ||
                this.projectSettingsViewModel.projectSettings.alertOnCardExpiringWithinDays <= 0
            ) {
                this.projectSettingsViewModel.projectSettings.alertOnCardExpiringWithinDays = 1
            }
            this.projectSettingsViewModel.hasChanged = true
        },
        showLog() {
            JsonApiObject.openDialog(LogActivityDialog, {})
        },
    },
    created() {
        if (!this.isModuleActive('personnel')) {
            this.$router.replace({
                name: 'project-dashboard',
                params: { type: this.$route.params.type, id: this.$route.params.id },
            })
            return
        }

        this.getSettings()
        this.getWorkAlerts()
    },
}
